import Vue from 'vue'
import Router from 'vue-router'

const Login = r =>
  require.ensure([], () => r(require('@/pages/login/login')), 'Login')
const Home = r =>
  require.ensure([], () => r(require('@/pages/home')), 'Home')
// 欢迎页
const Index = r =>
  require.ensure([], () => r(require('@/pages/index')), 'Index')
// *********************************************新闻模块***********************************************//
const newsList = r =>
  require.ensure([], () => r(require('@/pages/news/list')), 'newsList')
const newsEdit = r =>
  require.ensure([], () => r(require('@/pages/news/edit')), 'newsEdit')
const imgsList = r =>
  require.ensure([], () => r(require('@/pages/pic/list')), 'imgsList')
const imgsEdit = r =>
  require.ensure([], () => r(require('@/pages/pic/edit')), 'imgsEdit')
const applicationcateList = r =>
  require.ensure([], () => r(require('@/pages/application/catelist')), 'applicationcateList')
const applicationcateEdit = r =>
  require.ensure([], () => r(require('@/pages/application/cateedit')), 'applicationcateEdit')
const solutioncateList = r =>
  require.ensure([], () => r(require('@/pages/solution/cateList')), 'solutioncateList')
const solutionList = r =>
  require.ensure([], () => r(require('@/pages/solution/list')), 'solutionList')
const solutioncateEdit = r =>
  require.ensure([], () => r(require('@/pages/solution/cateEdit')), 'solutioncateEdit')
const applicationList = r =>
  require.ensure([], () => r(require('@/pages/application/list')), 'applicationList')
const applicationEdit = r =>
  require.ensure([], () => r(require('@/pages/application/edit')), 'applicationEdit')
const solutionEdit = r =>
  require.ensure([], () => r(require('@/pages/solution/edit')), 'solutionEdit')
// 产品分类列表
const productioncateList = r =>
  require.ensure([], () => r(require('@/pages/production/cateList')), 'productioncateList')
// 产品分类添加、修改
const productioncateEdit = r =>
  require.ensure([], () => r(require('@/pages/production/cateEdit')), 'productioncateEdit')
// 产品列表
const productionList = r =>
  require.ensure([], () => r(require('@/pages/production/list')), 'productionList')
// 产品添加、修改
const productionEdit = r =>
  require.ensure([], () => r(require('@/pages/production/edit')), 'productionEdit')

const featuresEdit = r =>
  require.ensure([], () => r(require('@/pages/production/features')), 'featuresEdit')

const techEdit = r =>
  require.ensure([], () => r(require('@/pages/production/tech')), 'techEdit')
Vue.use(Router)
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // 编辑应用案例的分类
    {
      path: '/application/cateedit/:mytype/:id?',
      name: 'applicationcateEdit',
      component: applicationcateEdit
    },
    {
      path: '/solution/cateedit/:mytype/:id?',
      name: 'solutioncateEdit',
      component: solutioncateEdit
    },
    {
      path: '/production/cateedit/:mytype/:id?',
      name: 'productioncateEdit',
      component: productioncateEdit
    },
    {
      path: '/production/features/:mytype/:pid/:id?',
      name: 'featuresEdit',
      component: featuresEdit
    },
    {
      path: '/production/tech/:mytype/:pid/:id?',
      name: 'techEdit',
      component: techEdit
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requireAuth: true
      },
      children: [{
        path: '/',
        name: 'index',
        component: Index
      }, {
        path: '/news/list',
        name: 'newsList',
        component: newsList
      }, {
        path: '/news/edit/:mytype/:id?',
        name: 'newsEdit',
        component: newsEdit
      }, {
        path: '/imgs/list/:pid',
        name: 'imgsList',
        component: imgsList
      }, {
        path: '/imgs/edit/:mytype/:pid/:id?',
        name: 'imgsEdit',
        component: imgsEdit
      },
      {
        path: '/application/catelist',
        name: 'applicationcateList',
        component: applicationcateList
      },
      {
        path: '/solution/catelist',
        name: 'solutioncateList',
        component: solutioncateList
      },
      {
        path: '/production/catelist',
        name: 'productioncateList',
        component: productioncateList
      },
      {
        path: '/application/list',
        name: 'applicationList',
        component: applicationList
      },
      {
        path: '/application/edit/:mytype/:id?',
        name: 'applicationEdit',
        component: applicationEdit
      },
      {
        path: '/solution/list',
        name: 'solutionList',
        component: solutionList
      },
      {
        path: '/solution/edit/:mytype/:id?',
        name: 'solutionEdit',
        component: solutionEdit
      },
      // 产品列表
      {
        path: '/production/list',
        name: 'productionList',
        component: productionList
      },
      // 产品编辑
      {
        path: '/production/edit/:mytype/:id?',
        name: 'productionEdit',
        component: productionEdit
      },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js